export function looksLikeGraphQlContent(content: string): boolean {
  const trimmedContent = content.trim();
  if (!trimmedContent) return false;

  if (/^(query|mutation|subscription|fragment)\b/i.test(trimmedContent)) {
    return true;
  }

  // Selection-set-only operations are valid GraphQL query syntax.
  if (
    trimmedContent.startsWith('{') &&
    !trimmedContent.includes('":') &&
    !trimmedContent.includes("':")
  ) {
    return true;
  }

  if (
    trimmedContent.includes('__schema') ||
    trimmedContent.includes('__type') ||
    trimmedContent.includes('fragment ')
  ) {
    return true;
  }

  return false;
}

export function isRawGraphQlRequestContentType(
  contentType: string | null | undefined,
): boolean {
  if (!contentType) return false;
  const normalizedType = contentType.toLowerCase().trim();
  return (
    normalizedType.startsWith('application/graphql') ||
    normalizedType.startsWith('text/graphql')
  );
}

/**
 * Detect if an HTTP body contains a GraphQL request.
 * Checks for JSON-envelope GraphQL ({"query":"..."}) or raw GraphQL content.
 */
export function isGraphQlBody({
  body,
  headerContentType,
}: {
  body: string;
  headerContentType: string | null;
}): boolean {
  const trimmed = body.trim();
  if (!trimmed) return false;

  if (
    isRawGraphQlRequestContentType(headerContentType) &&
    looksLikeGraphQlContent(trimmed)
  ) {
    return true;
  }

  if (!headerContentType?.includes('json') && headerContentType) return false;

  try {
    const parsed: unknown = JSON.parse(trimmed);
    if (typeof parsed !== 'object' || parsed === null) return false;
    const rec = parsed as Record<string, unknown>;
    return typeof rec.query === 'string' && looksLikeGraphQlContent(rec.query);
  } catch {
    return false;
  }
}
